import PropTypes from 'prop-types';
import { SoyuzExperiment, trans } from '@spotahome/soyuz/client';

import HowToBook from './HowToBook';
import HowToBookRedesign from './HowToBookRedesign';

import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';

import { ListingSectionObservable } from './ListingSection';

const ListingHowToBook = ({
  hasVetting = false,
  hasRentCollection = false
}) => (
  <ListingSectionObservable section="howToBook">
    <ListingTitle role="secondary">
      {trans('listing.how-to-book.section-main-title')}
    </ListingTitle>
    <SoyuzExperiment name="HowToBookRedesign">
      {experiment =>
        experiment.get('behaviour') === 'variant' ? (
          <HowToBookRedesign hasVetting={hasVetting} />
        ) : (
          <HowToBook
            hasRentCollection={hasRentCollection}
            hasVetting={hasVetting}
          />
        )
      }
    </SoyuzExperiment>
  </ListingSectionObservable>
);

ListingHowToBook.propTypes = {
  hasRentCollection: PropTypes.string,
  hasVetting: PropTypes.bool
};

export default ListingHowToBook;
